import React from 'react';
import ImageSlider from './ImageSlider';
import CategoryCardView from './CategoryCardView';

const SliderAndCategoryView = ({ onCardClick, showImageSlider, children }) => {
  return (
    <div>
      {showImageSlider && <ImageSlider />}
      <div className="categories-full-bleed">
        <CategoryCardView onCardClick={onCardClick} />
      </div>
      {children && <div className="home-section">{children}</div>}
    </div>
  );
};

export default SliderAndCategoryView;
